<script>
  import SignupModal from '../../components/shared/SignupModal.svelte'
  import { signUp } from '../../js-core/conn/auth/auth-main'
  let signUpFunc = (email, password, businessName, extraVals={}, creditCardToken) => {
    const signUpRes = {}
    const caller = async () => {
      const res = await signUp({email, password, businessName, creditCardToken}, 'ad-owner')
      signUpRes.message = res
      return signUpRes
    };
    return caller()
  } 
</script>

<SignupModal 
  signupFunc={signUpFunc}
  creditCardInfo=true
  signupUrl="/#/advertiser/sign-up"
/>

